import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const NotificationSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2 18.4616C2 19.1607 2.53366 19.6285 3.42612 19.6285H8.21005C8.28434 21.6508 9.82676 23.3681 12 23.3681C14.1639 23.3681 15.7062 21.6602 15.7899 19.6285H20.5739C21.4663 19.6285 22 19.1607 22 18.4616C22 17.3898 20.9372 16.438 20.0304 15.4974C19.2353 14.6558 19.0998 12.9317 18.9669 11.4704C18.8392 7.54294 17.7571 4.93484 14.9836 3.98186C14.6517 2.57646 13.5344 1.5 12 1.5C10.4699 1.5 9.34829 2.57646 9.01635 3.98186C6.2429 4.93484 5.16086 7.54294 5.02373 11.4704C4.90022 12.9317 4.75955 14.6558 3.97382 15.4974C3.05767 16.438 2 17.3898 2 18.4616ZM3.82349 18.1982V18.0703C3.98337 17.6982 4.65827 17.005 5.24483 16.363C6.11791 15.4114 6.38374 13.766 6.5293 11.6025C6.67394 7.29456 7.97806 5.78626 9.82062 5.27766C10.1125 5.20625 10.2732 5.06993 10.2901 4.79076C10.3502 3.68047 10.9857 2.89273 12 2.89273C13.0049 2.89273 13.6498 3.68047 13.7048 4.79076C13.7216 5.06993 13.8876 5.20625 14.17 5.27766C16.022 5.78626 17.3261 7.29456 17.4707 11.6025C17.6205 13.766 17.8863 15.4114 18.7552 16.363C19.3418 17.005 20.0209 17.6982 20.1765 18.0703V18.1982H3.82349ZM9.67802 19.6285H14.322C14.2402 21.0992 13.2973 22.0402 12 22.0402C10.6933 22.0402 9.75982 21.0992 9.67802 19.6285Z"
        fill={color}
      />
    </svg>
  );
};

export { NotificationSvg };
